// extracted by mini-css-extract-plugin
module.exports = {"root":"snippet-footnote-body_root__EaQYX"};